import React, { Component } from 'react';
import { connect } from 'react-redux';
// import { CopyToClipboard } from 'react-copy-to-clipboard';
import { decorateEmoji } from '../utils/emojiText';

var linkifyHtml = require('linkifyjs/html');

export class ChatBoxMessageListItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isHovering: false,
            //value: "",
            //copied: false,
        };
    }

    escapeHTML = (html) => {
        return html.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    };

    toggleHoverState = () => {
        this.setState({ isHovering: !this.state.isHovering });
    };

    handleCopyClick = () => {
    };

    render() {
        let date;
        let dateParts;
        let monthDayYearStr;
        let dayOfWeekIndex;
        let fullDate;
        let dateSeparator;
        let timeStamp;

        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

        date = new Date(this.props.message.createAt).toLocaleString().split(',')[0]
        dateParts = date.split("/"); // ["9", "16", "2019"]
        monthDayYearStr = months[(dateParts[0] - 1)] + " " + dateParts[1] + ", " + dateParts[2]; //"September 16, 2019"
        dayOfWeekIndex = new Date(monthDayYearStr).getDay();
        fullDate = "" + days[(7 + dayOfWeekIndex - 1) % 7] + ", " + monthDayYearStr;

        dateSeparator = this.props.message.firstMessageOfDay ?
            <div style={{ cursor: 'default' }}>
                <h2 style={{ width: '100%', lineHeight: '0.1em', borderBottom: '1px solid #a1a1a1', textAlign: 'center', margin: '18px 0 20px' }}>
                    <span style={{ fontSize: '12px', fontStyle: 'italic', color: '#a1a1a1', backgroundColor: 'white', padding: '0 10px' }}>
                        {fullDate}
                    </span>
                </h2>
            </div> : "";

        // The same rule-with-a-knockout-label device as the date separator, in
        // the colour this chat already uses for the other person, so it reads as
        // a sibling marker rather than something bolted on. Upright and a little
        // heavier than the italic grey date, because it marks your place rather
        // than the passage of time.
        const unreadSeparator = this.props.firstUnseen ?
            <div style={{ cursor: 'default' }}>
                <h2 style={{ width: '100%', lineHeight: '0.1em', borderBottom: '1px solid #408ec9', textAlign: 'center', margin: '18px 0 20px' }}>
                    <span style={{ fontSize: '12px', fontWeight: '500', color: '#408ec9', backgroundColor: 'white', padding: '0 10px' }}>
                        New messages
                    </span>
                </h2>
            </div> : "";

        timeStamp = (new Date(this.props.message.createAt).toLocaleString()).replace(/:\d+ /, ' ').split(',')[1] + " ";
        if (timeStamp.length === 9) {
            timeStamp = " 0" + timeStamp.slice(0, 0) + timeStamp.slice(1);
        }

        return (
            <div style={{ overflowWrap: 'break-word', cursor: 'default' }} //wordBreak: 'break-all'
                onMouseEnter={this.toggleHoverState}
                onMouseLeave={this.toggleHoverState}
            >
                {dateSeparator}
                {unreadSeparator}
                <b>
                    <font color={this.props.profile.id === this.props.message.userId ? '#d97c77' : '#408ec9'}>
                        {timeStamp}
                        {this.props.memberIdMap[this.props.message.userId].username + ": "}
                    </font>
                </b>
                {/* Escape, then linkify, then enlarge the emoji - in that
                    order. decorateEmoji has to see the anchors linkify emits
                    so it can step over them; run first, it would be scanning
                    text that is about to be rewritten. */}
                <span style={{ fontWeight: '500' }} dangerouslySetInnerHTML={{ __html: decorateEmoji(linkifyHtml(this.escapeHTML(this.props.message.message), {})) }} />
                {/*
        {this.state.isHovering &&
          <CopyToClipboard
          text={this.state.value}
          onCopy={() => this.setState({ copied: true })}
          >
            <i className="material-icons" fontSize="small" onClick={this.handleCopyClick} style={{ fontSize: '14px', width: '0px', paddingLeft: '3px', cursor: 'pointer' }}>
              file_copy_outlined
            </i>
          </CopyToClipboard>
        }
        */}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        members: state.members,
        profile: state.profile,
        currentUser: state.currentUser,
        memberIdMap: state.memberIdMap,
        memberNameMap: state.memberNameMap,
    };
}

export default connect(mapStateToProps, null)(ChatBoxMessageListItem);


// WEBPACK FOOTER //
// ./src/components/ChatBoxMessageListItem.js


// WEBPACK FOOTER //
// ./src/components/ChatBoxMessageListItem.js